// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2e-Qe","disabled":"FileBtn_disabled__1z-mH","warn":"FileBtn_warn__NkT8s","fade":"FileBtn_fade__3WDlf"};